"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/LSFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_138)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_138`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 15.9719H30V23.9719H-6V15.9719Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.207 12L11.7474 10.379C11.8877 9.96492 12.1053 9.95791 12.2456 10.379L12.786 12L14.1474 14.0421C14.2667 14.2246 14.2386 14.4842 14.0632 14.6035C14.0632 14.6035 13.5789 15.1649 11.993 15.1649C10.407 15.1649 9.9228 14.6035 9.9228 14.6035C9.75438 14.4632 9.71929 14.2246 9.83859 14.0421L11.207 12Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 12C11.1228 12 10.414 11.2912 10.414 10.414C10.414 9.53684 11.1228 8.82806 12 8.82806C12.8772 8.82806 13.586 9.53684 13.586 10.414C13.586 11.2912 12.8702 12 12 12ZM12 12C12.4351 12 12.793 10.8561 12.793 10.414C12.793 9.97894 12.4351 9.62105 12 9.62105C11.5649 9.62105 11.207 9.97894 11.207 10.414C11.207 10.8561 11.5579 12 12 12Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_138`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as LSFlag };
